import { InstructionFormDetails } from '../../commonAfterFormPage/InstructionFormDetails';
import TransferIcon from '@app/images/transfer.svg';
import ArrowsIcon from '@app/images/arrows.svg';
import config from '@app/config';
import { hsbcPaymentInstructionsAddress, hsbcPaymentInstructionsLines } from './hsbcAccountDetails';

export const HSBCPingPongFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.hsbcPingPong.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: hsbcPaymentInstructionsLines,
  paymentInstructionsAddress: hsbcPaymentInstructionsAddress,
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.transferMustBe',
      'supplierValidation.afterRegister.bofaPingPong.pleaseNote',
    ],
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: [
    { icon: TransferIcon, text: 'supplierValidation.afterRegister.hsbcPingPong.step1' },
    { icon: ArrowsIcon, text: 'supplierValidation.afterRegister.hsbcPingPong.step2' },
  ],
  downloadLink: `${config.supplierValidationAttachmentsUrl}HSBCPingPong/en/hsbc-ping-pong.pdf`,
};
